var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-benefits-lower-risk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F85",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5F9E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design-Discovery-6",
    transform: "translate(-1052.000000, -3069.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-benefits-lower-risk",
    transform: "translate(1052.000000, 3069.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "url(#linearGradient-1)",
    cx: 45,
    cy: 45,
    r: 45
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(23.000000, 23.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5221006,34.362626 L25.4679716,1.96108512 C24.7930172,0.751024861 23.5074756,0 22.1145979,0 L21.8854021,0 C20.4925244,0 19.2070687,0.751110088 18.5320284,1.96202262 L0.478071246,34.362626 C0.164742509,34.9246163 0,35.5593056 0,36.2003017 C0,38.2954497 1.71875336,40 3.83135904,40 L40.1686409,40 C42.2812466,40 44,38.2954497 44,36.2003017 C44,35.5593056 43.8353434,34.9246163 43.5221006,34.362626 Z M29.1131897,23.3185037 L18.1131682,36.0457842 C17.9323553,36.2535689 17.676347,36.3635976 17.4167293,36.3635976 C17.2537915,36.3635976 17.089049,36.3209839 16.9422675,36.2321768 C16.5591573,36.0013807 16.399743,35.5299021 16.5662902,35.1171452 L19.7299135,27.2726343 L15.583421,27.2726343 C15.2844439,27.2726343 15.0051465,27.1287703 14.8332711,26.8873207 C14.6632005,26.6458712 14.6202317,26.3359839 14.720435,26.0581422 L19.3037486,13.3308617 C19.4344598,12.9686448 19.7800152,12.7271952 20.1667347,12.7271952 L26.5834425,12.7271952 C26.8878337,12.7271952 27.1724593,12.8771957 27.3425299,13.1267418 C27.5126006,13.3762028 27.5466319,13.6940162 27.4338817,13.9737329 L24.2702583,21.8182438 L28.4167508,21.8182438 C28.7748531,21.8182438 29.1006428,22.025091 29.2493149,22.3473362 C29.3996199,22.6695814 29.3459089,23.0495257 29.1131897,23.3185037 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiRisk);
export default __webpack_public_path__ + "static/media/ui_risk.c4e6026639102d1d1a718feaa0759a31.svg";
export { ForwardRef as ReactComponent };